import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import { Button, Box, Card, CardContent, CardHeader, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ServerCall from '../../serverCall';
import { fmtDate, StatusChip, DetailRow } from './Helpers';

const CompanyDetails = ({ user, company }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error] = useState(null);
  const serverCall = ServerCall();

  // sync company data functionality
  const onSyncCompany = async () => {
    if(company.status == "PENDING") {
      //when the company is created and data isn't inputted. When user need the link again.
      navigate(`/source-select?user=${user.uid}&name=${company.companyName}`);
    }
    else {
      //when the user need to refresh the data. Payment is needed
      const payload = {
        companyName: company.companyName,
        companyId: company.id,
        reason: "Edit"
      };
      setLoading(true);
      try {
        const response = await serverCall.customAxios.post(
          '/company',
          payload,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
        const sessionUrl = response.data.sessionUrl;
  
        // Redirect to the sessionUrl
        window.location.href = sessionUrl;
      } catch (error) {
        console.error(error);
        toast.error("Failed to Sync Company...");
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading) return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Box>
  );
  if (error) return <Typography color="error">Error fetching company data</Typography>;
  if (!company) return <Typography>No company data available</Typography>;

  return (
    <Card sx={{ minHeight: 205, display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<InfoOutlinedIcon color="action" />}
        title="Company Detail"
        titleTypographyProps={{ variant: 'h6' }}
        action={company.userId !== "sandbox"
          && <Button variant='contained' onClick={() => { onSyncCompany() }}>Sync data</Button>}
        className="mr-10"
      />
      <Divider />
      <CardContent sx={{ flex: 1, overflow: 'auto' }}>
        <Grid container spacing={12} className="mb-2 px-10">
          <Grid item xs={12} md={6}>
            <DetailRow label="Company Name" value={company.companyName} />
          </Grid>
          <Grid item xs={12} md={6}>
            <DetailRow label="Status" value={<StatusChip value={company.status} />} />
          </Grid>
        </Grid>
        <Grid container spacing={12} className="px-10">
          <Grid item xs={12} md={6}>
            <DetailRow label="Created Date" value={company.userId === "sandbox" ? "-" : fmtDate(company.createdAt)} />
            <DetailRow label="Updated Date" value={company.userId === "sandbox" ? "-" : fmtDate(company.updatedAt)} />
          </Grid>
          {company.status === "COMPLETED" && <Grid item xs={12} md={6}>
            <DetailRow
              label="Earliest Available Date"
              value={company.id === "manualCompany" ? "-" : fmtDate(company.companyInfo.earlistDate)}
            />
            <DetailRow
              label="Latest Available Date"
              value={company.id === "manualCompany" ? "-" : fmtDate(company.companyInfo.latestDate)}
            />
          </Grid>}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CompanyDetails;
